<template>
  <modal showClose wrapperClasses="cancel-edit-member-offer-modal" @close="$emit('close')">
    <template #header>
      <h3 class="title">cancel offer</h3>
    </template>
    <template #body>
      <div class="body">
        <p>
          We've noticed that this offer is empty, would you like to delete
          the offer or save it for later
        </p>
      </div>
    </template>
    <template #action>
      <div class="actions">
        <button class="button" @click="$emit('delete')">delete offer</button>
        <button class="link-button" @click="$emit('save')">save offer for later</button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../../components/shared/Modal";

export default {
  name: "CancelEditModal",
  components: {
    Modal,
  },
};
</script>

<style lang="scss" scoped>
.cancel-edit-member-offer-modal::v-deep {
  > .modal {
    flex-shrink:0;
    width: 100%;
    max-width: 500px;
  }

  > .modal .title {
    font-size: 26px;
    padding-top: 0;
    font-weight: bold;
  }

  .actions {
    display: grid;
    grid-gap: 12px;
    max-width: 240px;
    margin: 30px auto 10px auto;
  }

  .button {
    font-size: 18px;
    padding: 8px 16px;
  }

  .link-button {
    font-size: 18px;
    color: #128ff9;
    cursor: pointer;
    font-family: 'AileronThin', sans-serif;
    &:hover {
      color: #016fb9;
    }
  }
}
</style>
